import { render, staticRenderFns } from "./EditArticleMovement.vue?vue&type=template&id=3c622628&scoped=true"
import script from "./EditArticleMovement.vue?vue&type=script&lang=js"
export * from "./EditArticleMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c622628",
  null
  
)

export default component.exports